import { getFamilyInviteCode } from "@utils/familyInvite";
import { getShopInviteCode } from "@utils/shopInviteCode";
import { getReferredCourierId, getReferredOrderId } from "@utils/referredCourier";

/** 後端 /app-api/line/register-by-serial：序號驗證後直接建帳（手機延到首次結帳驗證）。 */
export interface RegisterBySerialBody {
  accessToken: string;
  verifiedTicket: string;
  courier_id?: string;
  order_id?: string;
  shop_code?: string;
  invite_code?: string;
}
export interface RegisterBySerialResult {
  jwtToken?: string;
  context_id?: number | null;
  order_id?: string | null;
  /** 只有練習站 mock 會帶：練習完成要導回練習完成頁、留在沙盒內。正式後端不回。 */
  redirectUrl?: string;
}
export const ALREADY_REGISTERED_MSG = "已經註冊過，不可重複註冊";

/** 欄位來源與舊 profile 頁送 /line/register 時相同；無值一律 undefined（不出現在 JSON）。 */
export const buildRegisterBySerialBody = (accessToken: string, verifiedTicket: string): RegisterBySerialBody => ({
  accessToken,
  verifiedTicket,
  courier_id: getReferredCourierId() ?? undefined,
  order_id: getReferredOrderId() ?? undefined,
  shop_code: getShopInviteCode() ?? undefined,
  invite_code: getFamilyInviteCode() ?? undefined,
});
